import { Grid, InputAdornment, Typography } from '@mui/material'
import { ChargeRate, TaxiRate } from 'api/vehicle/taxisRatesAPI.types'
import FormInput from 'components/FormFields/FormInput/FormInput'
import styles from 'components/Supplier/Manage/manageSupplierStyle'
import React, { Dispatch } from 'react'

interface Props {
  taxiRate?: TaxiRate | undefined
  waitingTime: string
  chargeRates: Array<ChargeRate>
  setChargeRates: Dispatch<React.SetStateAction<Array<ChargeRate>>>
  isEdit: boolean
  additionalStop: boolean
  waitAndReturn: boolean
}
interface ChargeRateException {
  chargeExceptionId: number
  chargeTypeName?: string
  premium?: number
  percentage?: number
}

export const StandardRateRow = (props: Props) => {
  const {
    taxiRate,
    waitingTime,
    chargeRates,
    setChargeRates,
    isEdit,
    additionalStop,
    waitAndReturn,
  } = props

  const handleChangeEvent = (
    event: React.BaseSyntheticEvent,
    index: number,
  ) => {
    const value: number = event.target.value
    const clonedRates: Array<ChargeRate> = [...chargeRates]
    let mappedExceptions: Array<ChargeRateException> = []
    const rate = clonedRates[index]
    rate.chargeExceptions.map((exception: any) => {
      if (exception.chargeTypeName === 'Percentage') {
        const percentage = exception?.percentage || 0
        let newPremium =
          (Number(percentage) / 100) * Number(value) + Number(value)
        mappedExceptions.push({
          ...exception,
          premium: newPremium,
        })
      } else {
        mappedExceptions.push(exception)
      }
    })
    clonedRates[index] = rate
    setChargeRates([...clonedRates])
  }

  return (
    <Grid container spacing={2} direction="row" alignItems="center">
      <Grid item xs={2}>
        <Typography>Standard Rate</Typography>
      </Grid>
      {/* <Grid item xs={1} />
      <Grid item xs={1} /> */}
      <Grid item xs={1}>
        <FormInput
          name={'minimumFare.price'}
          InputProps={{
            startAdornment: <InputAdornment position="start">£</InputAdornment>,
          }}
          type="tel"
          sx={styles.inputField}
          disabled={!isEdit}
          defaultValue={
            taxiRate?.minimumFare?.price
              ? Number(taxiRate?.minimumFare?.price).toFixed(2)
              : ''
          }
        />
      </Grid>
      {waitingTime === 'grace' && (
        <Grid item xs={1}>
          <FormInput
            name={'waitingTime.gracePeriod.price'}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">£</InputAdornment>
              ),
            }}
            type="tel"
            sx={styles.inputField}
            disabled={!isEdit}
            defaultValue={
              taxiRate?.waitingTime?.gracePeriod?.price
                ? Number(taxiRate?.waitingTime?.gracePeriod?.price).toFixed(2)
                : ''
            }
          />
        </Grid>
      )}
      {waitingTime !== '' && (
        <Grid item xs={1}>
          <FormInput
            name={'waitingTime.chargingPeriod.price'}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">£</InputAdornment>
              ),
            }}
            type="tel"
            sx={styles.inputField}
            disabled={!isEdit}
            defaultValue={
              taxiRate?.waitingTime?.chargingPeriod?.price
                ? Number(taxiRate?.waitingTime?.chargingPeriod?.price).toFixed(
                    2,
                  )
                : ''
            }
          />
        </Grid>
      )}
      {waitAndReturn && (
        <Grid item xs={1}>
          <FormInput
            name={'waitAndReturn.chargingPeriod.price'}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">£</InputAdornment>
              ),
            }}
            type="tel"
            sx={styles.inputField}
            disabled={!isEdit}
            defaultValue={
              taxiRate?.waitAndReturn?.chargingPeriod?.price
                ? Number(
                    taxiRate?.waitAndReturn?.chargingPeriod?.price,
                  ).toFixed(2)
                : ''
            }
          />
        </Grid>
      )}
      {additionalStop && (
        <Grid item xs={1}>
          <FormInput
            name={'additionalStop.price'}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">£</InputAdornment>
              ),
            }}
            type="tel"
            sx={styles.inputField}
            disabled={!isEdit}
            defaultValue={
              taxiRate?.additionalStop?.price
                ? Number(taxiRate?.additionalStop?.price).toFixed(2)
                : ''
            }
          />
        </Grid>
      )}
      {chargeRates.map((chargeRate, i) => {
        return (
          <Grid item key={i} xs={1}>
            <FormInput
              name={`chargeRates[${i}].pricePerMile`}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">£</InputAdornment>
                ),
              }}
              type="tel"
              sx={styles.inputField}
              onChange={(event) => handleChangeEvent(event, i)}
              disabled={!isEdit}
              defaultValue={
                chargeRates[i].pricePerMile
                  ? Number(chargeRates[i].pricePerMile).toFixed(2)
                  : ''
              }
            />
          </Grid>
        )
      })}
    </Grid>
  )
}
export default StandardRateRow
